import styled, { css } from 'styled-components'

const fontStyle = css`
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 36px;
  color: #35324A;
`

const FilterFont = css`
  font-family: "AeonikPro-Regular";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
`

export const AppTitle = styled.div`
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  color: #35324A;
  padding-top: 16px;
  font-family: 'AeonikPro-Medium'
`

export const AppDescription = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: '#35324A';
  margin-top: 8px;
  line-height: 21px;
  fontFamily: AeonikPro-Regular;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: initial;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
`

export const IconWrapper = styled.img`
  width:48px;
  height:48px;
  margin-right: 10px;
  cursor: pointer;
  -webkit-user-drag: none;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  &::selection {
    border: 1px solid #ddd;
  }
`
export const Header = styled.div`
  ${fontStyle}
  font-family: "AeonikPro-Medium";
  line-height: 36px;
`

export const FilterHeader = styled.div`
  ${fontStyle}
  font-size: 20px;
  line-height: 160%;
  letter-spacing: 0.15px;
  font-family: "AeonikPro-Medium";
`
export const FilterNameBold = styled.div`
  ${FilterFont}
  font-weight: 700;
  margin-top: 7px;
  padding: 6px 0px 8px 0px;
  border-radius: 5px;
  background: #F1F1EE;
  margin-bottom: -9px;
`
export const FilterName = styled.div`
  ${FilterFont}
  margin-top: 20px;
`
